export type CodedError = Error & {
  code: string
  fieldErrors?: Record<string, string[]>
  retryAfterMs?: number
}

export const codedError = (code: string, message: string): CodedError => {
  const error = new Error(message) as CodedError

  error.code = code

  return error
}

export const notAuthenticated = (): CodedError =>
  codedError("not_authenticated", "Not signed in")

export const protocolError = (detail: string): CodedError =>
  codedError("protocol_error", `Malformed bulk response: ${detail}`)
